import {AxiosResponse, CancelToken} from 'axios';
import {ApplicationCategory} from '../backend/interfaces/application-category';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class ApplicationCategoriesRepository {
  // Singleton Instance
  private static _instance: ApplicationCategoriesRepository;

  // Private
  private logger: Logger;

  static get instance(): ApplicationCategoriesRepository {
    if (!this._instance) {
      this._instance = new ApplicationCategoriesRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('ApplicationCategoriesRepository');
  }

  // Get an application category by id
  public async getById(
    id: string,
    localize: boolean,
    cancelToken?: CancelToken
  ): Promise<ApplicationCategory> {
    // Set url
    let url: string = `/application-categories/${id}?localize=${localize}`;

    // Get application category from backend
    const result: AxiosResponse<ApplicationCategory> =
      await BackendApiManager.instance.get<ApplicationCategory>(url, {cancelToken});

    // Return
    return result.data;
  }
}
